<template>
  <span>
    <IntroSection />

    <MedicineAboutSection />

    <CompanionGroups />

    <FeaturedDoctorsSection />

    <!-- <OurBlogSection /> -->

    <!-- <OurClientsSection /> -->

    <HealthSpecialistSection />

    <FooterMenuSection />
  </span>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { ensureInitialGeolocation } from "@/helpers/geolocationHelper";
import { useSeo, jsonLd } from "@/composables/useSeo";

import MedicineAboutSection from "@/components/home/sections/medicineAbout/medicineAboutSection.vue";
//import OurBlogSection from "@/components/home/sections/ourBlog/ourBlogSection.vue";
import FeaturedDoctorsSection from "@/components/home/sections/featuredDoctors/featuredDoctorsSection.vue";
import IntroSection from "@/components/home/sections/intro/introSection.vue";
import CompanionGroups from "@/components/companionGroups/companionGroups.vue";

//import OurClientsSection from "@/components/home/sections/ourClients/ourClientsSection.vue";
import HealthSpecialistSection from "@/components/home/sections/healthSpecialist/healthSpecialistSection.vue";
import FooterMenuSection from "@/components/home/sections/footerMenu/footerMenuSection.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    MedicineAboutSection,
    FooterMenuSection,
    HealthSpecialistSection,
    // OurClientsSection,
    // OurBlogSection,
    FeaturedDoctorsSection,
    IntroSection,
    CompanionGroups,
  },
  setup() {
    const { t } = useI18n();
    useSeo({
      title: t("seoHomeTitle"),
      description: t("seoHomeDesc"),
      jsonLd: [jsonLd.webSite(), jsonLd.organization()],
    });

    onMounted(() => {
      ensureInitialGeolocation();

      // Menú hamburguesa
      //      $('.hamburger').click(() => {
      //       $('.offcanvasMenu').toggleClass('show');
      //      });

      /*

      // Botón de volver arriba
      $(window).on('scroll', () => {
        if ($(this).scrollTop() > 600) {
          $('.back-to-top').fadeIn(200);
        } else {
          $('.back-to-top').fadeOut(200);
        }
      });
*/

      document
        .querySelector(".back-to-top")
        ?.addEventListener("click", function (event) {
          event.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        });
    });
  },
});
</script>
